const CLUSTER = "cluster";
const SUB_CLUSTER = "subcluster";
const PREVENT_FREE_TIER_PARAM = "prevent_free_tier";
const CUSTOM_FLOW_PARAM = "custom_flow";
const SUPPORTED_OVERRIDE_QUERY_PARAMS = [
    CLUSTER,
    SUB_CLUSTER
];
const FORCE_PRICING = "force_pricing";
const FORCE_CURRENCY = "force-currency";
const ACTIVE_TAB_ID = "ati";
const FROM_PARAM = "from";
const LOCALE = "locale";
const PRODUCT_PARAM = "product";
module.exports = {
    CLUSTER,
    SUB_CLUSTER,
    PREVENT_FREE_TIER_PARAM,
    CUSTOM_FLOW_PARAM,
    SUPPORTED_OVERRIDE_QUERY_PARAMS,
    FORCE_PRICING,
    FORCE_CURRENCY,
    ACTIVE_TAB_ID,
    FROM_PARAM,
    LOCALE,
    PRODUCT_PARAM
};
